// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.messageConversation {
  display: flex;
  /* display: none; */
  flex-direction: column;
  width: 100%;
  border-radius: 1em;
  background: var(--clr-gray200);
}

.messageConversation__header {
  display: flex;
  position: relative;
  align-items: center;
  padding: 1em;
  background: var(--clr-gray200);
  border-radius: 1em;
}

.messageConversation__details {
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;
  justify-content: space-between;
}

.messageConversation .loading-container-text {
  text-align: center;
}

.three-dots {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  cursor: pointer;
}

.three-dots span {
  width: 0.25rem;
  height: 0.25rem;
  border-radius: 50%;
  background: var(--clr-gray500);
}

.messageConversation__proposal {
  margin: 1rem 0;
}

.messageConversation__personImgContainer {
  position: relative;
  margin-right: 1rem;
}

.messageConversation__personImgContainer::after {
  content: "";
  position: absolute;
  width: 0.5rem;
  height: 0.5rem;
  background: var(--clr-success-dark);
  border-radius: 50%;
  right: -0.25rem;
  border: 0.2rem solid var(--clr-light);
  bottom: 0;
}

.messageConversation__personImgContainer img {
  display: block;
  width: 2.5rem;
  height: 2.5rem;
  /* max-width: 3.5rem;
  height: 3.5rem; */
  aspect-ratio: 1 / 1;
  background: var(--clr-gray200);
  object-fit: cover;
  /* margin-right: 0.25rem; */
  /* margin-right: 1rem; */
  border-radius: 50%;
}

.messageConversation__expertise,
.messageConversation__personName,
.messageConversation__destination {
  font-size: 0.9rem;
  color: var(--clr-gray800);
  width: 100%;
  /* max-width: 9rem; */
  /* white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis; */
}

.messageConversation__personName {
  font-family: "Avenir Next";
  /* color: var(--clr-primary); */
  font-weight: bolder;
  /* white-space: nowrap; */
}

.messageConversation__destination,
.messageConversation__expertise {
  display: block;
  margin-top: 0.5rem;
}

.messageConversation__chatContainer {
  /* padding: 2em; */
  padding: 1em;
  display: flex;
  /* height: 100%; */
  margin-top: 2rem;
  overflow-y: scroll;
  scrollbar-width: none;
  background: var(--clr-gray200);
  border: 0.1rem solid var(--clr-gray);
  border-bottom: none;
  border-radius: 1em 1em 0 0;
  /* height: calc(100% - 7.5rem); */
  height: 35rem;
  position: relative;
  padding-top: 4em;

  /* flex-direction: column-reverse; */
  flex-direction: column;
}

.messageConversation__chatContainer::-webkit-scrollbar {
  display: none;
}

.messageConversation__chatBubble {
  width: 100%;
  /* width: 80%; */
  display: flex;
  margin-bottom: 2rem;
}
/* 
.messageConversation__chatBubble:first-of-type {
  margin-bottom: 0;
} */

.messageConversation__chatBubble:last-of-type {
  margin-bottom: 0;
}

.messageConversation__chatBubble.right {
  display: flex;
  margin-left: auto;
  flex-direction: row-reverse;
}

.messageConversation__chatBubbleAvatar {
  display: block;
  width: 100%;
  max-width: 2.5rem;
  height: 2.5rem;
  aspect-ratio: 1 / 1;
  border-radius: 50%;
  object-fit: cover;
}

.messageConversation__chatBubble.right
  .messageConversation__chatBubbleContent
  > span {
  text-align: right;
}

.messageConversation__chatBubbleContent > span {
  margin: 0.5rem;
  font-weight: 700;
  display: block;
}

.messageConversation__chatBubbleContentMessage {
  margin: 0 0.5rem;
  padding: 1em;
  background: var(--clr-primary-dark200);
  color: var(--clr-light);
  line-height: 1.8;
  font-size: 0.9rem;
  border-radius: 0 1.5em 1.5em 1.5em;
}

.messageConversation__chatBubbleContentMessage table {
  background: transparent !important;
}

.messageConversation__chatBubbleContentMessage table tr {
  display: flex;
  margin: 0.15rem 0;
}

.messageConversation__chatBubbleContentMessage svg {
  fill: none;
  width: 1.25rem;
  height: 1.25rem;
  margin-right: 0.75rem;
}

.messageConversation__chatBubbleContentMessage svg.bi.bi-gift {
  fill: #fff;
  width: 1rem;
  height: 1rem;
}

.messageConversation__chatBubbleImageContainer {
  display: flex;
  /* display: grid; */
  grid-gap: 0.5rem;
  gap: 0.5rem;
  place-items: center;
  grid-template-columns: repeat(2, minmax(11rem, 1fr));
}

.messageConversation__chatBubbleImageContainer.file {
  display: flex;
  flex-direction: column;
  place-items: unset;
}

.messageConversation__chatBubbleImage {
  max-width: 11rem;
  margin-top: 0.25rem;
  max-height: 7rem;
  object-fit: contain;
}

.messageConversation__chatBubbleImage:hover {
  cursor: zoom-in;
  opacity: 0.75;
}

.messageConversation__chatBubbleContentMessage p {
  color: var(--clr-light);
}

.messageConversation__chatBubbleContentMessage a {
  /* color: var(--clr-primary-dark200); */
  text-decoration: underline;
}

.messageConversation__chatBubble.right
  .messageConversation__chatBubbleContentMessage {
  border-radius: 1.5em 0 1.5em 1.5em;
  background: var(--clr-primary-dark);
}

.messageConversation__inputContainer {
  display: flex;
  width: 100%;
  position: relative;
  border-radius: 0 0 1em 1em;
  /* padding: 2em; */
  padding: 1em;
  background: var(--clr-gray200);
  border: 0.1rem solid var(--clr-gray);
  border-top: none;
  align-items: flex-end;
  /* align-items: center; */
}

.messageConversation__inputContainer > div {
  width: 100%;
}

/* set this later for interlocutors */
.messageCoversation__onInput {
  display: none;
  position: absolute;
  top: -0.1rem;
  left: 3rem;
  font-size: 0.9rem;
  color: var(--clr-gray500);
}

.messageConversation__inputContainer textarea {
  outline: none;
  border: none;
  width: 100%;
  font-size: 1rem;
  padding: 1em;
  height: 3.125rem;
  /* height: 100%; */
  /* border: 1px solid #000; */
  resize: none;
  background: transparent;
  scrollbar-width: 0;
}

.messageConversation__inputContainer textarea::-webkit-scrollbar {
  width: 0;
}

.messageConversation__sendBtn .loading-animation {
  left: 0;
}

.messageConversation__uploadImage,
.messageConversation__sendBtn {
  border-radius: 0.75em;
  padding: 1em 1.75em;
}

.messageConversation__uploadImage svg,
.messageConversation__sendBtn svg {
  width: 1.5rem;
}

.messageConversation__uploadImage {
  margin-left: 0.5rem;
  background: transparent;
  position: relative;
}

.messageConversation__uploadImage svg {
  fill: var(--clr-gray500);
}

.messageConversation__chatImgContainer {
  display: grid;
  gap: 0.5rem;
  grid-template-columns: repeat(auto-fill, minmax(5rem, 1fr));
}

.messageConversation__chatImg {
  position: relative;
  margin-bottom: 0.5rem;
}

.messageConversation__chatImg img {
  max-width: 5rem;
  object-fit: contain;
  max-height: 3rem;
}

.messageConversation__uploadImage input {
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;
  z-index: 1;
  cursor: pointer;
  opacity: 0;
}

.messageConversation__chatImg .messageConversation__closeIcon {
  top: -0.5rem;
  width: 1rem;
  left: -0.5rem;
  filter: invert(1);

  position: absolute;
  cursor: pointer;
  z-index: 1;
}

.messageConversation__chatFileContainer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.messageConversation__chatBubbleImgFile,
.messageConversation__chatImgFile {
  display: flex;
  align-items: center;
  font-size: 0.8rem;
  width: -moz-fit-content;
  width: fit-content;
  padding: 0.25em 1.25em;
}

.messageConversation__chatBubbleImgFile svg,
.messageConversation__chatImgFile svg {
  margin-right: 0.25rem;
  width: 2rem;
}

.messageConversation__chatBubbleImgFile {
  font-size: 0.9rem;
}

@media (min-width: 992px) {
  .messageConversation {
    grid-column: span 2;
    border-left: 0.1rem solid var(--clr-gray);
    border-radius: 0 1em 1em 0;
    overflow: hidden;
    box-shadow: 0.5rem 0.75rem 1rem rgba(0, 0, 0, 0.04);
  }

  .messageConversation__header {
    border-radius: 0;
    padding: 2em;
  }

  .messageConversation__chatContainer {
    border-radius: 0;
    padding: 2em;
    border: none;
    margin-top: 0;
    padding-top: 5em;
  }

  .messageConversation__inputContainer {
    border-radius: 0;
    padding: 2em;
    border: none;
  }

  .messageConversation__personImgContainer::after {
    width: 0.75rem;
    height: 0.75rem;
    right: -0.25rem;
    border: 0.3rem solid var(--clr-light);
    bottom: -0.25rem;
  }

  .messageConversation__personImgContainer img {
    width: 3.5rem;
    height: 3.5rem;
    aspect-ratio: 1 / 1;
  }

  .messageConversation__proposal {
    display: none;
  }
}

@media (min-width: 1200px) {
  .messageConversation {
    display: flex;
    width: 100%;
    flex: 1 1 45%;
    border-radius: 0;
  }

  .three-dots {
    display: none;
  }

  .messageConversation__personName {
    color: var(--clr-primary);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/MessageComponents/MessageConversation/MessageConversation.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,mCAAmC;EACnC,kBAAkB;EAClB,eAAe;EACf,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd;mBACiB;EACjB,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,2BAA2B;EAC3B,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;;;EAGE,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX,qBAAqB;EACrB;;4BAE0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,8BAA8B;EAC9B,oCAAoC;EACpC,mBAAmB;EACnB,0BAA0B;EAC1B,iCAAiC;EACjC,aAAa;EACb,kBAAkB;EAClB,gBAAgB;;EAEhB,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;AACA;;;GAGG;;AAEH;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;;EAGE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,sCAAsC;EACtC,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uCAAuC;EACvC,0BAA0B;AAC5B;;AAEA;;EAEE,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,YAAY;EACZ,8BAA8B;EAC9B,oCAAoC;EACpC,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,OAAO;AACT;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,2DAA2D;AAC7D;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,YAAY;EACZ,WAAW;EACX,UAAU;EACV,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,iBAAiB;;EAEjB,kBAAkB;EAClB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,uBAAkB;EAAlB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;EAEE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,mBAAmB;IACnB,yCAAyC;IACzC,0BAA0B;IAC1B,gBAAgB;IAChB,mDAAmD;EACrD;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,cAAc;IACd,eAAe;IACf,eAAe;IACf,qCAAqC;IACrC,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;IACb,WAAW;IACX,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".messageConversation {\n  display: flex;\n  /* display: none; */\n  flex-direction: column;\n  width: 100%;\n  border-radius: 1em;\n  background: var(--clr-gray200);\n}\n\n.messageConversation__header {\n  display: flex;\n  position: relative;\n  align-items: center;\n  padding: 1em;\n  background: var(--clr-gray200);\n  border-radius: 1em;\n}\n\n.messageConversation__details {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  position: relative;\n  justify-content: space-between;\n}\n\n.messageConversation .loading-container-text {\n  text-align: center;\n}\n\n.three-dots {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n  cursor: pointer;\n}\n\n.three-dots span {\n  width: 0.25rem;\n  height: 0.25rem;\n  border-radius: 50%;\n  background: var(--clr-gray500);\n}\n\n.messageConversation__proposal {\n  margin: 1rem 0;\n}\n\n.messageConversation__personImgContainer {\n  position: relative;\n  margin-right: 1rem;\n}\n\n.messageConversation__personImgContainer::after {\n  content: \"\";\n  position: absolute;\n  width: 0.5rem;\n  height: 0.5rem;\n  background: var(--clr-success-dark);\n  border-radius: 50%;\n  right: -0.25rem;\n  border: 0.2rem solid var(--clr-light);\n  bottom: 0;\n}\n\n.messageConversation__personImgContainer img {\n  display: block;\n  width: 2.5rem;\n  height: 2.5rem;\n  /* max-width: 3.5rem;\n  height: 3.5rem; */\n  aspect-ratio: 1 / 1;\n  background: var(--clr-gray200);\n  object-fit: cover;\n  /* margin-right: 0.25rem; */\n  /* margin-right: 1rem; */\n  border-radius: 50%;\n}\n\n.messageConversation__expertise,\n.messageConversation__personName,\n.messageConversation__destination {\n  font-size: 0.9rem;\n  color: var(--clr-gray800);\n  width: 100%;\n  /* max-width: 9rem; */\n  /* white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis; */\n}\n\n.messageConversation__personName {\n  font-family: \"Avenir Next\";\n  /* color: var(--clr-primary); */\n  font-weight: bolder;\n  /* white-space: nowrap; */\n}\n\n.messageConversation__destination,\n.messageConversation__expertise {\n  display: block;\n  margin-top: 0.5rem;\n}\n\n.messageConversation__chatContainer {\n  /* padding: 2em; */\n  padding: 1em;\n  display: flex;\n  /* height: 100%; */\n  margin-top: 2rem;\n  overflow-y: scroll;\n  scrollbar-width: none;\n  background: var(--clr-gray200);\n  border: 0.1rem solid var(--clr-gray);\n  border-bottom: none;\n  border-radius: 1em 1em 0 0;\n  /* height: calc(100% - 7.5rem); */\n  height: 35rem;\n  position: relative;\n  padding-top: 4em;\n\n  /* flex-direction: column-reverse; */\n  flex-direction: column;\n}\n\n.messageConversation__chatContainer::-webkit-scrollbar {\n  display: none;\n}\n\n.messageConversation__chatBubble {\n  width: 100%;\n  /* width: 80%; */\n  display: flex;\n  margin-bottom: 2rem;\n}\n/* \n.messageConversation__chatBubble:first-of-type {\n  margin-bottom: 0;\n} */\n\n.messageConversation__chatBubble:last-of-type {\n  margin-bottom: 0;\n}\n\n.messageConversation__chatBubble.right {\n  display: flex;\n  margin-left: auto;\n  flex-direction: row-reverse;\n}\n\n.messageConversation__chatBubbleAvatar {\n  display: block;\n  width: 100%;\n  max-width: 2.5rem;\n  height: 2.5rem;\n  aspect-ratio: 1 / 1;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.messageConversation__chatBubble.right\n  .messageConversation__chatBubbleContent\n  > span {\n  text-align: right;\n}\n\n.messageConversation__chatBubbleContent > span {\n  margin: 0.5rem;\n  font-weight: 700;\n  display: block;\n}\n\n.messageConversation__chatBubbleContentMessage {\n  margin: 0 0.5rem;\n  padding: 1em;\n  background: var(--clr-primary-dark200);\n  color: var(--clr-light);\n  line-height: 1.8;\n  font-size: 0.9rem;\n  border-radius: 0 1.5em 1.5em 1.5em;\n}\n\n.messageConversation__chatBubbleContentMessage table {\n  background: transparent !important;\n}\n\n.messageConversation__chatBubbleContentMessage table tr {\n  display: flex;\n  margin: 0.15rem 0;\n}\n\n.messageConversation__chatBubbleContentMessage svg {\n  fill: none;\n  width: 1.25rem;\n  height: 1.25rem;\n  margin-right: 0.75rem;\n}\n\n.messageConversation__chatBubbleContentMessage svg.bi.bi-gift {\n  fill: #fff;\n  width: 1rem;\n  height: 1rem;\n}\n\n.messageConversation__chatBubbleImageContainer {\n  display: flex;\n  /* display: grid; */\n  grid-gap: 0.5rem;\n  gap: 0.5rem;\n  place-items: center;\n  grid-template-columns: repeat(2, minmax(11rem, 1fr));\n}\n\n.messageConversation__chatBubbleImageContainer.file {\n  display: flex;\n  flex-direction: column;\n  place-items: unset;\n}\n\n.messageConversation__chatBubbleImage {\n  max-width: 11rem;\n  margin-top: 0.25rem;\n  max-height: 7rem;\n  object-fit: contain;\n}\n\n.messageConversation__chatBubbleImage:hover {\n  cursor: zoom-in;\n  opacity: 0.75;\n}\n\n.messageConversation__chatBubbleContentMessage p {\n  color: var(--clr-light);\n}\n\n.messageConversation__chatBubbleContentMessage a {\n  /* color: var(--clr-primary-dark200); */\n  text-decoration: underline;\n}\n\n.messageConversation__chatBubble.right\n  .messageConversation__chatBubbleContentMessage {\n  border-radius: 1.5em 0 1.5em 1.5em;\n  background: var(--clr-primary-dark);\n}\n\n.messageConversation__inputContainer {\n  display: flex;\n  width: 100%;\n  position: relative;\n  border-radius: 0 0 1em 1em;\n  /* padding: 2em; */\n  padding: 1em;\n  background: var(--clr-gray200);\n  border: 0.1rem solid var(--clr-gray);\n  border-top: none;\n  align-items: flex-end;\n  /* align-items: center; */\n}\n\n.messageConversation__inputContainer > div {\n  width: 100%;\n}\n\n/* set this later for interlocutors */\n.messageCoversation__onInput {\n  display: none;\n  position: absolute;\n  top: -0.1rem;\n  left: 3rem;\n  font-size: 0.9rem;\n  color: var(--clr-gray500);\n}\n\n.messageConversation__inputContainer textarea {\n  outline: none;\n  border: none;\n  width: 100%;\n  font-size: 1rem;\n  padding: 1em;\n  height: 3.125rem;\n  /* height: 100%; */\n  /* border: 1px solid #000; */\n  resize: none;\n  background: transparent;\n  scrollbar-width: 0;\n}\n\n.messageConversation__inputContainer textarea::-webkit-scrollbar {\n  width: 0;\n}\n\n.messageConversation__sendBtn .loading-animation {\n  left: 0;\n}\n\n.messageConversation__uploadImage,\n.messageConversation__sendBtn {\n  border-radius: 0.75em;\n  padding: 1em 1.75em;\n}\n\n.messageConversation__uploadImage svg,\n.messageConversation__sendBtn svg {\n  width: 1.5rem;\n}\n\n.messageConversation__uploadImage {\n  margin-left: 0.5rem;\n  background: transparent;\n  position: relative;\n}\n\n.messageConversation__uploadImage svg {\n  fill: var(--clr-gray500);\n}\n\n.messageConversation__chatImgContainer {\n  display: grid;\n  gap: 0.5rem;\n  grid-template-columns: repeat(auto-fill, minmax(5rem, 1fr));\n}\n\n.messageConversation__chatImg {\n  position: relative;\n  margin-bottom: 0.5rem;\n}\n\n.messageConversation__chatImg img {\n  max-width: 5rem;\n  object-fit: contain;\n  max-height: 3rem;\n}\n\n.messageConversation__uploadImage input {\n  position: absolute;\n  top: 0;\n  height: 100%;\n  width: 100%;\n  z-index: 1;\n  cursor: pointer;\n  opacity: 0;\n}\n\n.messageConversation__chatImg .messageConversation__closeIcon {\n  top: -0.5rem;\n  width: 1rem;\n  left: -0.5rem;\n  filter: invert(1);\n\n  position: absolute;\n  cursor: pointer;\n  z-index: 1;\n}\n\n.messageConversation__chatFileContainer {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n.messageConversation__chatBubbleImgFile,\n.messageConversation__chatImgFile {\n  display: flex;\n  align-items: center;\n  font-size: 0.8rem;\n  width: fit-content;\n  padding: 0.25em 1.25em;\n}\n\n.messageConversation__chatBubbleImgFile svg,\n.messageConversation__chatImgFile svg {\n  margin-right: 0.25rem;\n  width: 2rem;\n}\n\n.messageConversation__chatBubbleImgFile {\n  font-size: 0.9rem;\n}\n\n@media (min-width: 992px) {\n  .messageConversation {\n    grid-column: span 2;\n    border-left: 0.1rem solid var(--clr-gray);\n    border-radius: 0 1em 1em 0;\n    overflow: hidden;\n    box-shadow: 0.5rem 0.75rem 1rem rgba(0, 0, 0, 0.04);\n  }\n\n  .messageConversation__header {\n    border-radius: 0;\n    padding: 2em;\n  }\n\n  .messageConversation__chatContainer {\n    border-radius: 0;\n    padding: 2em;\n    border: none;\n    margin-top: 0;\n    padding-top: 5em;\n  }\n\n  .messageConversation__inputContainer {\n    border-radius: 0;\n    padding: 2em;\n    border: none;\n  }\n\n  .messageConversation__personImgContainer::after {\n    width: 0.75rem;\n    height: 0.75rem;\n    right: -0.25rem;\n    border: 0.3rem solid var(--clr-light);\n    bottom: -0.25rem;\n  }\n\n  .messageConversation__personImgContainer img {\n    width: 3.5rem;\n    height: 3.5rem;\n    aspect-ratio: 1 / 1;\n  }\n\n  .messageConversation__proposal {\n    display: none;\n  }\n}\n\n@media (min-width: 1200px) {\n  .messageConversation {\n    display: flex;\n    width: 100%;\n    flex: 1 1 45%;\n    border-radius: 0;\n  }\n\n  .three-dots {\n    display: none;\n  }\n\n  .messageConversation__personName {\n    color: var(--clr-primary);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
